'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');
const Subscriptions = require('./subscriptions');
const Orders = require('./orders');
const Users = require('./users');

class Customer {
  constructor(credentials, request, sdkConfiguration) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager();
    this.credentials = credentials;
    this.request = request;
    this.sdkConfiguration = sdkConfiguration;
  }

  byId(customerId) {
    this.customerId = customerId;
    this.paramsManager.addPathParam(customerId);
    this.subscriptions = new Subscriptions(this.credentials, this.request, this.sdkConfiguration, this.customerId);
    this.orders = new Orders(this.credentials, this.request, this.sdkConfiguration, this.customerId);
    this.users = new Users(this.credentials, this.request, this.sdkConfiguration, this.customerId);
    return this;
  }

  get() {
    this.validateCustomerId();
    this.requestManager.requestConfigurationManager.setApi('GetCustomerProfile');
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getCompanyProfile() {
    this.validateCustomerId();
    this.requestManager.requestConfigurationManager.setApi('GetCompanyProfile');
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getBillingProfile() {
    this.validateCustomerId();
    this.requestManager.requestConfigurationManager.setApi('GetBillingProfile');
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  search(size, filter) {
    filter = encodeURIComponent(JSON.stringify(filter));
    this.requestManager.requestConfigurationManager.setApi('GetCustomerList');
    this.paramsManager.addQueryParam({ size }, { filter });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  list(size, continuation, seekOperation = 'Next') {
    if (!size) {
      throw errorHandler.handleError('Size expected');
    }
    this.requestManager.requestConfigurationManager.setApi('GetCustomerList');
    if (continuation) {
      this.paramsManager.addHeaderParams('MS-ContinuationToken', continuation);
      this.paramsManager.addQueryParam({ seekOperation });
    } else {
      this.paramsManager.addQueryParam({ size });
    }
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  create(CompanyProfile, BillingProfile) {
    this.requestManager.requestConfigurationManager.setApi('CreateCustomer');
    this.paramsManager.addBodyParams({ CompanyProfile, BillingProfile });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  update(profile, Etag) {
    this.requestManager.requestConfigurationManager.setApi('UpdateCustomer');
    this.paramsManager.addBodyParams(profile);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  validateCustomerId() {
    if (!this.customerId) {
      throw errorHandler.handleError('To use this function, first use the byId function, to set the customerId');
    }
  }
}

module.exports = Customer;
